import { Input, InputChangeEvent } from "@progress/kendo-react-inputs";
import React from "react";

import { useSearchBar } from "./SearchBarHook";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";

interface SearchBarProps {
  onChangeValue: (event: InputChangeEvent) => void;
}
export const SearchBar: React.FunctionComponent<SearchBarProps> = (props) => {
  const { classNames } = useSearchBar();

  return (
    <div className="ms-Grid px-3 py-2">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
          <div className={classNames.formField}>
            <Input
              id="search_edit"
              className={classNames.searchBar}
              placeholder={formatMessage("cof.base.searchbar")}
              onChange={props.onChangeValue}
            />
            <img alt="search_icon" src={"/assets/search.png"} className={classNames.icon} />
          </div>
        </div>
      </div>
    </div>
  );
};
